module.exports = __webpack_public_path__ + "img/college_icon6.9da2d7d.png";